import React from 'react'
import _ from 'lodash'

function append_image_url(objs, image_urls, key = 'image') {
  return _.map(objs, (obj, idx) => {
    obj[key] = image_urls[idx]
    return obj
  })
}

// really really dumb limited fix
function html_decode(input) {
  let str = input
  str = str.replace(/&#039;/, "'")
  str = str.replace(/&gt;/, '>')
  return str
}

function safe_load_wp(input) {
  if (!input) {
    return
  }
  if (
    input.includes('<p>') ||
    input.includes('</p>') ||
    input.includes('<div>') ||
    input.includes('</div>')
  ) {
    return <div dangerouslySetInnerHTML={{ __html: input }} />
  } else {
    return <p dangerouslySetInnerHTML={{ __html: input }} />
  }
}

function strip_tags(input) {
  return input.replace(/<div>|<\/div>|<p>|<\/p>/g, '')
}

export { strip_tags, append_image_url, html_decode, safe_load_wp }
